module.exports = __webpack_public_path__ + "img/须田侑太郎.bf286b49.png";